import { formatNumber } from '../my_time_record/timeUnits';

export const UNIT_DAYS = 'days';
export const UNIT_HOURS = 'hours';
export const DASH = '–';

/**
 * The summary always arrives in days; the Hours/Days toggle converts here, once,
 * so the cells and the tiles cannot round differently.
 */
export function toUnit(days, unit, hoursInDay) {
    const number = Number(days) || 0;

    return unit === UNIT_HOURS ? Math.round(number * (Number(hoursInDay) || 8) * 100) / 100 : number;
}

/**
 * A cell: the dash for nothing recorded, otherwise the figure in the chosen unit.
 */
export function formatCellValue(days, unit, hoursInDay) {
    if (days === null || days === undefined) {
        return DASH;
    }

    return formatNumber(toUnit(days, unit, hoursInDay)) || DASH;
}

/**
 * A total: zero reads as 0 rather than a dash, since the week was counted.
 */
export function formatTotalValue(days, unit, hoursInDay) {
    return formatNumber(toUnit(days, unit, hoursInDay)) || '0';
}

export function shortUnit(unit) {
    return unit === UNIT_HOURS ? $t('h') : $t('d');
}
